import React, { useEffect, useRef } from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * TradingView free Advanced Chart
 */
const LiveTradingViewChart = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    container.innerHTML = '';

    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    widgetDiv.style.height = '100%';
    widgetDiv.style.width = '100%';
    container.appendChild(widgetDiv);

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.text = JSON.stringify({
      autosize: true,
      symbol: 'OANDA:XAUUSD',
      interval: '15',
      timezone: 'Etc/UTC',
      theme: 'dark',
      style: '1',
      locale: 'en',
      enable_publishing: false,
      allow_symbol_change: false,
      hide_top_toolbar: false,
      hide_legend: false,
      save_image: false,
      calendar: false,
      support_host: 'https://www.tradingview.com',
      studies: ['STD;RSI', 'STD;MACD', 'STD;SMA'],
      backgroundColor: 'rgba(13, 17, 23, 1)',
      gridColor: 'rgba(51, 51, 51, 0.4)',
    });
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  return (
    <Paper sx={{ p: 1, bgcolor: '#1A1A1A', border: '1px solid #333', overflow: 'hidden' }}>
      <Typography variant="subtitle2" color="primary.main" sx={{ px: 1, pt: 1, pb: 0.5 }} fontWeight="bold">
        Live Chart · TradingView
      </Typography>
      <Box
        ref={containerRef}
        className="tradingview-widget-container"
        sx={{ width: '100%', height: { xs: 420, md: 560 } }}
      />
      <Typography variant="caption" color="text.secondary" display="block" textAlign="center" py={1}>
        Live ticks · RSI / MACD / SMA
      </Typography>
    </Paper>
  );
};

export default LiveTradingViewChart;
